import DateTimePicker from '@components/v2/form/DateTimePicker/DateTimePicker';
import { Box } from '@mui/material';
import { useCatalogCreationAccessDateCell } from '../hooks/useCatalogCreationAccessDateCell';

interface CatalogCreationAccessDateCellProps {
  value: Date | null;
  testId: string;
  isDisabled?: boolean;
  onChange: (date: Date | null) => void;
}

const CatalogCreationAccessDateCell = ({
  value,
  testId,
  isDisabled,
  onChange,
}: CatalogCreationAccessDateCellProps) => {
  const { hasInvalidDate, handleChangeDate } = useCatalogCreationAccessDateCell({ onChange });

  return (
    <Box test-id={testId}>
      <DateTimePicker
        size="small"
        value={value}
        error={hasInvalidDate}
        disabled={isDisabled}
        onChange={handleChangeDate}
      />
    </Box>
  );
};

export default CatalogCreationAccessDateCell;
